import { createContext, useContext, useState, useEffect } from "react";

const NotificationContext = createContext();

// Notification styles for different states
const notificationStyles = {
  success: "bg-green-500 text-white",
  error: "bg-red-500 text-white",
  warning: "bg-orange-500 text-white",
};

// Notification component
const Notification = ({ message, type, onClose, duration }) => {
  const [exiting, setExiting] = useState(false);

  useEffect(() => {
    // Start exit animation before onClose
    const timer = setTimeout(() => setExiting(true), duration - 500);
    const exitTimer = setTimeout(onClose, duration);

    // Auto-remove notification after duration
    // const timer = setTimeout(onClose, duration);
    // return () => clearTimeout(timer);

    return () => {
      clearTimeout(timer);
      clearTimeout(exitTimer);
    };
  }, [onClose, duration]);

  return (
    <div
      className={`px-2 py-1 rounded-md shadow-md mb-1 transform transition-all duration-500 ease-in-out
        ${notificationStyles[type]}
        ${exiting ? "animate-slide-out" : "animate-slide-in"}
      `}
    >
      {message}
    </div>
  );
};

// NotificationContainer to manage and display notifications
export const NotificationProvider = ({ children }) => {
  const [notifications, setNotifications] = useState([]);

  const addNotification = (message, type, duration = 4000) => {
    setNotifications((prevNotifications) => [
      ...prevNotifications,
      { id: Date.now(), message, type, duration },
    ]);
  };

  const removeNotification = (id) => {
    setNotifications((prevNotifications) =>
      prevNotifications.filter((notification) => notification.id !== id)
    );
  };

  return (
    <NotificationContext.Provider value={addNotification}>
      {children}
      <div className="fixed top-12 right-4 flex flex-col items-end space-y-1 z-50">
        {notifications.map((notification) => (
          <Notification
            key={notification.id}
            message={notification.message}
            type={notification.type}
            duration={notification.duration}
            onClose={() => removeNotification(notification.id)}
          />
        ))}
      </div>
    </NotificationContext.Provider>
  );
};

// Custom hook for accessing the addNotification function
export const useNotification = () => useContext(NotificationContext);
